export function toHashrate(
  hashrate: number | string,
  currency: string | undefined,
): string {
  let prefix = ["LTC", "RVN"].includes(currency || "") ? " GH/s" : " TH/s";
  if (["LTC", "RVN"].includes(currency || "")) {
    return (+hashrate / 1000).toFixed(3) + prefix;
  }
  if (typeof hashrate !== "number") {
    return hashrate.toString();
  }
  if (currency === "ZEC") {
    if (hashrate <= 1) {
      return hashrate.toFixed(3) + " KSol/s";
    } else if (hashrate < 1_000) {
      return hashrate.toFixed(3) + " MSol/s";
    } else if (hashrate < 1_000_000) {
      return (hashrate / 1_000).toFixed(3) + " GSol/s";
    } else {
      return (hashrate / 1_000_000).toFixed(3) + " TSol/s";
    }
  }
  if (hashrate < 1_000_000_000) {
    return (hashrate / 1_000_000).toFixed(3) + " TH/s";
  } else if (hashrate < 1_000_000_000_000) {
    return (hashrate / 1_000_000_000).toFixed(3) + " PH/s";
  } else {
    return (hashrate / 1_000_000_000_000).toFixed(3) + " EH/s";
  }
}
export function getHashrateValue(
  hashrate: number,
  currency: string,
): {
  val: string;
  unit: string;
} {
  if (["LTC", "RVN"].includes(currency)) {
    return {
      val: (hashrate / 1000).toFixed(3),
      unit: " GH/s",
    };
  }
  if (currency === "ZEC") {
    if (hashrate <= 1) {
      return {
        val: hashrate.toFixed(3),
        unit: " KSol/s",
      };
    } else if (hashrate < 1_000) {
      return {
        val: hashrate.toFixed(3),
        unit: " MSol/s",
      };
    } else if (hashrate < 1_000_000) {
      return {
        val: (hashrate / 1_000).toFixed(3),
        unit: " GSol/s",
      };
    } else {
      return {
        val: (hashrate / 1_000_000).toFixed(3),
        unit: " TSol/s",
      };
    }
  }
  if (hashrate < 1_000_000_000) {
    return {
      val: (hashrate / 1_000_000).toFixed(3),
      unit: " TH/s",
    };
  } else if (hashrate < 1_000_000_000_000) {
    return {
      val: (hashrate / 1_000_000_000).toFixed(3),
      unit: " PH/s",
    };
  } else {
    return {
      val: (hashrate / 1_000_000_000_000).toFixed(3),
      unit: " EH/s",
    };
  }
}
export function expo(x: number, f: number) {
  return Number.parseFloat(x as any).toExponential(f);
}
